export function mapStateToProps(state) {
  return {
    clientSideRendered: state.clientSideRendered
  };
}
export function mapDispatchToProps(dispatch) {
  return {};
}